module.exports = __webpack_public_path__ + "img/DNADamage-PDAC_GSE111672.f535fe42.png";